import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'sst-risk-questionnaire';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Risk Questionnaire',
};

const sstRiskQuestionnaire = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstRiskQuestionnaire };
